module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ep-radio"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b2be7e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/radio/src/radio.vue
// module id = 1250
// module chunks = 2